import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';

// For runtime configurations, necessary for running in different environments
/*
declare global {
  interface Window { config: {apiURL:string, ENV:string} }
}
*/

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);